import React, { useEffect, useState } from 'react';
import { db } from '../firebase/firebaseConfig';
import { collection, getDocs } from 'firebase/firestore';

const ItemCollection = () => {
  const [items, setItems] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('All');

  const formatDate = (value) => {
    try {
      if (!value) return 'N/A';
      if (typeof value === 'string') return value;
      if (value.toDate) return value.toDate().toLocaleString();
      return new Date(value.seconds * 1000).toLocaleString();
    } catch {
      return 'Invalid Date';
    }
  };

  useEffect(() => {
    const fetchItems = async () => {
      try {
        // Fetch from lostItems
        const lostSnapshot = await getDocs(collection(db, 'lostItems'));
        const lostItems = lostSnapshot.docs.map(doc => ({
          id: doc.id,
          type: 'Lost',
          ...doc.data(),
        }));

        // Fetch from claims
        const claimSnapshot = await getDocs(collection(db, 'claims'));
        const claimedItems = claimSnapshot.docs.map(doc => ({
          id: doc.id,
          type: 'Claimed',
          ...doc.data(),
        }));

        // Combine all
        const allItems = [...lostItems, ...claimedItems];
        setItems(allItems);
      } catch (error) {
        console.error('Error fetching items:', error);
      }
    };

    fetchItems();
  }, []);

  const filteredItems = items.filter(item => {
    const matchesSearch = (
      item.itemName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.description?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.location?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.yourName?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const matchesStatus =
      statusFilter === 'All' ||
      item.itemStatus?.toLowerCase() === statusFilter.toLowerCase() ||
      item.type?.toLowerCase() === statusFilter.toLowerCase();

    return matchesSearch && matchesStatus;
  });

  return (
    <div style={{ padding: '2rem' }}>
      <h2>Items Collection</h2>

      {/* 🔍 Search + 🔽 Filter */}
      <div style={{ display: 'flex', gap: '1rem', marginBottom: '1.5rem', flexWrap: 'wrap' }}>
        <input
          type="text"
          placeholder="Search by name, description, location or person"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            padding: '0.5rem',
            width: '250px',
            borderRadius: '5px',
            border: '1px solid #ccc',
          }}
        />

        <select
          value={statusFilter}
          onChange={(e) => setStatusFilter(e.target.value)}
          style={{
            padding: '0.5rem',
            borderRadius: '5px',
            border: '1px solid #ccc',
          }}
        >
          <option value="All">All Statuses</option>
          <option value="Found">Found</option>
          <option value="Lost">Lost</option>
          <option value="Claimed">Claimed</option>
        </select>
      </div>

      {/* 📝 Results */}
      {filteredItems.length === 0 ? (
        <p>No items found.</p>
      ) : (
        <ul style={{ listStyleType: 'none', padding: 0 }}>
          {filteredItems.map(item => (
            <li
              key={item.id}
              style={{
                background: '#f0f0f0',
                marginBottom: '1rem',
                padding: '1rem',
                borderRadius: '8px',
              }}
            >
              <h3>{item.itemName || 'Unnamed Item'}</h3>
              <p><strong>Type:</strong> {item.type}</p>
              <p><strong>Status:</strong> <span data-testid="status-text">{item.itemStatus || 'N/A'}</span></p>
              <p><strong>Date:</strong> {formatDate(item.dateLost || item.dateClaimed)}</p>
              <p><strong>Location:</strong> {item.location || 'N/A'}</p>
              <p><strong>Description:</strong> {item.description || 'N/A'}</p>
              <p><strong>Submitted By:</strong> {item.yourName || 'N/A'} ({item.email || 'No email'})</p>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ItemCollection;
